import { render, staticRenderFns } from "./JinzhiReport.vue?vue&type=template&id=7d48fb06&scoped=true&"
import script from "./JinzhiReport.vue?vue&type=script&lang=js&"
export * from "./JinzhiReport.vue?vue&type=script&lang=js&"
import style0 from "./JinzhiReport.vue?vue&type=style&index=0&id=7d48fb06&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48fb06",
  null
  
)

export default component.exports